import styled from "@emotion/styled"
import Roller from "components/roller/Roller"
import { headline50 } from "css/text"

const Root = styled(Roller)`
  padding-block-start: 0;

  > div {
    margin: 0;
  }

  h2 {
    ${headline50}
    padding-block-end: 2rem;
  }

  .previous {
    grid-column: 2 !important;
    justify-self: start !important;
  }
  .next {
    grid-column: 13 !important;
    justify-self: end !important;
  }
`

export default function TestimoneeRoller(props) {
  const data = props.content[0]?.roller?.roller?.[0]
  return <Root {...data} />
}
